export default {"src":"/_next/static/media/close-black.68095192.svg","height":30,"width":30};